import type { FaireProductEntity } from "../../entity_types/product";

export const p_25phypp2mt: FaireProductEntity = {
  token: "p_25phypp2mt",
  type: "product",
  name: "THE MARFA CANDLE",
  brandToken: "b_7ydvwmgrd6",
  brandName: "NOAH MARION",
  imageUrl:
    "https://cdn.faire.com/fastly/750ce2b0d8d1612a0752854a1589f618174bbda272a75c1b39143f0cb54bee55.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/134e6868cebb938e38b7e62214a745411304f7abfb37d2819399093aa5504dc5.png",
  ],
  priceDollars: 28.8,
  description:
    "• Hand Poured\n\n• Organic Soy Wax Recyclable Vessel\n\n• 125ml - 250ml\n\n• MARFA - Cactus Flower | Tar | Texas Sage",
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:27.974Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
